import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isInvalid: boolean }>`
    color: rgba(255, 255, 255, 0.5);
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.3px;

    position: absolute;
    left: 100%;
    bottom: 0;
    margin-left: 7px;
    opacity: 0;

    transition:
        color 0.2s ease-in-out,
        opacity 0.2s ease-in-out;

    ${({ $isInvalid }) =>
        $isInvalid &&
        css`
            color: #ff0000;
            opacity: 1;
        `}
`;
